import React from 'react'

const VerticalSpacer = () => (
  <div style={{ marginBottom: '10px' }} />
)

export default VerticalSpacer
